import React from 'react';
import cn from 'classnames';

import { WatchedAsset } from '@kaltura-ott/tvpil-shared';

import ContinueWatchingCardContainer from 'components/widgets/CardView/ContinueWatching/ContinueWatchingCardContainer/ContinueWatchingCardContainer';
import DynamicRailViewer from 'components/widgets/Rail/components/DynamicRailViewer/DynamicRailViewer';
import { useRailContext } from 'components/widgets/Rail/components/RailProvider/RailProvider';
import Title from 'components/widgets/Rail/components/Title/Title';
import { useApplyStyles } from 'components/widgets/Rail/hooks/useApplyStyles/useApplyStyles';
import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import styles from './ContinueWatchingRailContainer.module.scss';

const ContinueWatchingRailContainer = () => {
  // using version v2 of the rail provider
  const { wrapperRef, refElementInner, componentHeight } = useRailContext();
  const {
    settings,
    data: { hasNextPage, totalCount, items },
    data,
  } = useWidgetContext<WatchedAsset>();

  const handleRef = useApplyStyles(settings);

  return (
    <div ref={handleRef} className={cn(styles.container)}>
      <div ref={refElementInner}>
        <Title
          hasNextPage={Boolean(hasNextPage)}
          totalCount={totalCount}
          itemsLength={items?.length}
          forwardHeaderRef={handleRef}
          railSettings={settings}
        />
        <div
          ref={wrapperRef}
          style={{
            height: componentHeight,
          }}
        >
          <DynamicRailViewer<WatchedAsset> railData={data}>
            {({ imageHeight, itemWidth, item }) => (
              <ContinueWatchingCardContainer imageHeight={imageHeight} itemWidth={itemWidth} item={item} />
            )}
          </DynamicRailViewer>
        </div>
      </div>
    </div>
  );
};

export default ContinueWatchingRailContainer;
